export const flattenCategories = (categories, level = 0) => {
  let result = [];

  categories.forEach((cat) => {
    result.push({
      _id: cat._id,           
      title: `${"— ".repeat(level)}${cat.title|| cat.pavilion_name || cat.name}`,
    });

    if (cat.children && cat.children.length > 0) {
      result = result.concat(
        flattenCategories(cat.children, level + 1)
      );
    }
  });

  return result;
};
